import { Button, Grid } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'
import ProjectCard from '../../Project/ProjectCard'

const RPContainer = styled.div`
  .card-wrapper.project {
    .MuiCard-root {
      .thumbnail-container {
        left: 50%;
        transform: scale(75%, 75%) translate(-66%, -75%);
      }
    }

    .MuiCardContent-root {
      background: rgba(255, 255, 255, 0.9);
    }
  }
`

interface Props {
  projects: Project[]
  handleEditViewClick: (project: Project) => void
  handleDeleteClick: (project: Project) => void
}

const RecentProjects = ({
  projects,
  handleEditViewClick,
  handleDeleteClick,
}: Props) => {
  let projectsClone = [...projects]
  const recentProjects = projectsClone.splice(0, 3)
  const history = useHistory()

  return (
    <RPContainer className="recent-projects m-b-32">
      <div className="title-bar m-b-16">
        <div className="title">Recent projects</div>
        <div className="actions">
          <Button
            variant="contained"
            color="primary"
            onClick={() => history.push('/myquality/projects')}
          >
            View all
          </Button>
        </div>
      </div>

      <Grid container spacing={2}>
        {recentProjects.map((project, index) => (
          <Grid item sm={4} key={index}>
            <ProjectCard
              project={project}
              handleEditViewClick={handleEditViewClick}
              handleDeleteClick={handleDeleteClick}
            />
          </Grid>
        ))}
      </Grid>
    </RPContainer>
  )
}

export default RecentProjects
